<script setup>
import { onErrorCaptured, ref } from 'vue';

const error = ref(null);
const errorInfo = ref(null);

onErrorCaptured((err, instance, info) => {
    error.value = err;
    errorInfo.value = info;
    console.error('ErrorBoundary caught error:', err, info);
    return false; // Prevent error from propagating further
});

const retry = () => {
    error.value = null;
    errorInfo.value = null;
};
</script>

<template>
    <div v-if="error">
        <div
            class="flex flex-col items-center justify-center gap-4 rounded-lg border border-red-200 bg-red-50 px-8 py-16"
        >
            <div class="text-red-600">
                <svg
                    class="size-16"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                >
                    <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                    />
                </svg>
            </div>
            <h2 class="text-lg font-bold text-red-900">
                {{ $t('errors.component_load_failed') }}
            </h2>
            <p class="text-sm text-red-700">{{ error.message }}</p>
            <button
                type="button"
                class="btn-primary"
                @click="retry"
            >
                {{ $t('button.retry') }}
            </button>
        </div>
    </div>
    <slot v-else />
</template>
